import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import customizeOffers from '../../redux/customize-offers';
import { Type, Divider, Stack } from "react-spark";

import configured from '../../forms/configured';
import button from '../../button';
import Form from '../../forms/form/Form';

const { LoanAmountSelect } = configured;
const { SubmitButton } = button;
const { actionCreator } = customizeOffers;

export class CustomizeOffersComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastSubmittedValue: false,
            submitDisabled: true,
        };

        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    onChange(inputName, inputData = this.props.maxOffer) {
        const { value } = inputData;
        if (value === '') {
            this.setState({
                requestedAmount: value,
            });
            return;
        }

        const amount = value;

        if (
            this.state.lastSubmittedValue
      && amount === this.state.lastSubmittedValue
        ) {
            this.setSubmitState(true);
        } else {
            this.setSubmitState();
        }

        this.setState({
            requestedAmount: amount,
        });
    }

    setSubmitState(state = false) {
        this.setState({ submitDisabled: state });
    }

    handleSubmit() {
        this.setSubmitState(true);
        const lastSubmittedValue = this.state.requestedAmount.toString().replace(/[^\d\.]/g, '');
        this.setState(
            {
                lastSubmittedValue,
            },
            () => {
                this.props.submit(lastSubmittedValue);
            }
        );
    }

    render() {
        const { requestedAmount } = this.state;
        const {
            clientStateMinAmount,
            customizedOffer,
            maxOffer,
            isTeamMember,
            getsQLDiscount,
            getsCyberMondayDiscount
        } = this.props;

        return (
            <Fragment>
                <Stack centerColumn>
                    <Stack.Item>
                        <Type.DisplaySix>
                            {'To see other offers with different rates, choose a loan amount here:'}
                        </Type.DisplaySix>
                    </Stack.Item>
                </Stack>
                <Stack centerRow className="sprk-u-TextAlign--center">
                    <Stack.Item className="sprk-o-Stack__item--center-column input-loan-amount sprk-u-Width-100">
                        <Form
                            id="loanAmountForm"
                            name="loanAmountForm"
                            onChange={this.onChange}
                            onSubmit={this.handleSubmit}
                        >
                            <Stack
                                splitAt="tiny"
                                className="sprk-u-ptm sprk-u-AbsoluteCenter"
                            >
                                <Stack.Item breakpoint="tiny" width="fifth">
                                    <LoanAmountSelect
                                        className="sprk-u-man"
                                        minAmount={clientStateMinAmount}
                                        maxAmount={maxOffer}
                                        value={requestedAmount || customizedOffer}
                                    />
                                </Stack.Item>
                                <Stack.Item breakpoint="tiny" width="sixth">
                                    <SubmitButton
                                        id="customizeOffersBtn"
                                        name="customizeOffersBtn"
                                        disabled={this.state.submitDisabled}
                                    >
                                        Submit
                                    </SubmitButton>
                                </Stack.Item>
                            </Stack>
                        </Form>
                        <Divider />
                        {isTeamMember && (
                            <p id="teamMemberSubHeading" className="sprk-b-TypeDisplaySeven">
                                Welcome Rock FOC Team Member! As
                                a reminder, any loan option you choose will
                                include 50% off the Origination Fee of the
                                loan.
                            </p>
                        )}
                        {getsCyberMondayDiscount && (
                            <p id="genericSubHeading" className="sprk-b-TypeDisplaySeven">
                                Don’t wait. 50% off your origination fee ends when Cyber Monday does.
                            </p>
                        )}
                        {getsQLDiscount && (
                            <p id="genericSubHeading" className="sprk-b-TypeDisplaySeven ">
                                Based on your credit report, we see you have an
                                active mortgage with our sister company, Rocket
                                Mortgage. As a thank you for being a valued
                                Rock Family of Companies client, see
                                your discounted rates below.
                            </p>
                        )}
                    </Stack.Item>
                </Stack>
            </Fragment>
        );
    }
}

CustomizeOffersComponent.propTypes = {
    clientStateMinAmount: PropTypes.number.isRequired,
    customizedOffer: PropTypes.number,
    maxOffer: PropTypes.number.isRequired,
    minOffer: PropTypes.number,
    submit: PropTypes.func.isRequired,
    getsQLDiscount: PropTypes.bool.isRequired,
    isTeamMember: PropTypes.bool.isRequired,
    getsCyberMondayDiscount: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => ({
    submit: (requestedAmount) =>  dispatch((_, getState) => {
        const state = getState();
        if (state && state.loan && state.loan.loanJson && state.loan.loanJson.loanId) {
            dispatch(actionCreator.submitAuthenticated(requestedAmount, state.loan.loanJson.loanId));
        } else {
            dispatch(actionCreator.submit(requestedAmount));
        }
    }),
});

export default connect(
    null,
    mapDispatchToProps
)(CustomizeOffersComponent);
